import status from '@cordel/helpers/colors/proposals';

const STATUS = {
  check: 'checagem',
  simulate: 'simulação',
  analyze: 'análise',
  hang: 'pendente',
  restrict: 'restrição',
  preapprove: 'pré_aprovada',
  approve: 'aprovada',
  refuse: 'recusada',
  formalize: 'formalizada',
  invoice: 'faturada',
  pay: 'pago',
  dismiss: 'desistencia',
  expire: 'expirada',
  cancel: 'cancelada',
};

Object.keys(STATUS).forEach((i) => {
  STATUS[i] = {
    identifier: STATUS[i],
    label: status(i),
    value: i,
  };
});

export default STATUS;
